import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Heart,
  Smile,
  Users,
  HandHeart,
  CheckCircle,
  UtensilsCrossed,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

const reasons = [
  {
    icon: Heart,
    title: "Dari Hati untuk Keluarga",
    description:
      "Setiap sajian kami dibuat dengan kasih dan niat ibadah, menghadirkan pengalaman aqiqah yang penuh makna bagi keluarga Anda.",
  },
  {
    icon: CheckCircle,
    title: "Amanah & Terpercaya",
    description:
      "Lebih dari satu dekade melayani keluarga Jabodetabek dengan standar halal, bersih, dan pelayanan profesional.",
  },
  {
    icon: Users,
    title: "Ribuan Keluarga Bahagia",
    description:
      "Telah dipercaya oleh lebih dari 5.000 keluarga untuk menangani momen aqiqah anak tercinta.",
  },
  {
    icon: Smile,
    title: "Pelayanan Ramah & Personal",
    description:
      "Kami bukan sekadar penyedia layanan, Toyibah Aqiqah merupakan teman perjalanan spiritual keluarga Anda.",
  },
  {
    icon: HandHeart,
    title: "Nilai Keberkahan",
    description:
      "Proses penyembelihan di Toyibah Aqiqah dilakukan sesuai syariat, penuh doa, dan niat ibadah agar setiap langkah membawa keberkahan.",
  },
  {
    icon: UtensilsCrossed,
    title: "Cita Rasa Istimewa",
    description:
      "Chef profesional kami mengolah daging kambing pilihan dengan bumbu khas yang menggugah selera tanpa bau prengus.",
  },
];

const WhyUs = () => {
  const [open, setOpen] = useState(false);

  return (
    <section
  id="whyus"
  className="relative py-10 md:py-20 px-6 bg-gradient-to-b from-[#FFFBF9] via-[#FFF7F4] to-[#FFFBF9] overflow-hidden"
>

      {/* 🌸 Decorative pattern */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto text-center">
        {/* ✨ Title */}
        <h2 className="text-3xl md:text-5xl font-extrabold text-[#333] mb-6">
          Kenapa <span className="text-[#FF8A65]">Toyibah Aqiqah?</span>
        </h2>

        {/* 🟠 Mobile Dropdown Toggle */}
        <div className="block md:hidden">
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center justify-center gap-2 bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white px-5 py-2 rounded-full mx-auto font-semibold shadow-md hover:scale-105 transition-all"
          >
            {open ? "Tutup Alasan" : "Lihat Alasan"}
            {open ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
          </button>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="mt-6 overflow-hidden"
              >
                <div className="grid grid-cols-2 gap-4">
                  {reasons.map((item, index) => {
                    const Icon = item.icon;
                    return (
                      <div
                        key={index}
                        className="bg-white/90 border border-[#FFD8C8]/50 rounded-2xl p-4 flex flex-col items-center text-center"
                      >
                        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white mb-2 shadow">
                          <Icon className="w-6 h-6" />
                        </div>
                        <h4 className="text-sm font-semibold text-[#333] mb-1">
                          {item.title}
                        </h4>
                      </div>
                    );
                  })}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* 🟢 Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-8 mt-12">
          {reasons.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="group bg-white/90 rounded-2xl border border-[#FFD8C8]/50 shadow-sm hover:shadow-lg transition-all p-6 flex flex-col items-center text-center"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white mb-4 shadow">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="font-semibold text-lg text-[#333] mb-2">
                  {item.title}
                </h3>
                <p className="text-[#777] text-sm">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
